import { IonButtons, IonCol, IonIcon, IonItem, IonLabel } from '@ionic/react';
import { musicalNote } from 'ionicons/icons';
import React, { useEffect } from 'react';
import { useArtists } from '../data/store/useArtists';
import { ArtistId } from '../models/Artist';
import ArtistButton from './ArtistButton';


interface ArtistItemProps {
  id: ArtistId;
}

const ArtistItem: React.FC<ArtistItemProps> = ({ id }) => {
  const artist = useArtists(x => x.retrieve(id));
  const fetch = useArtists(x => x.fetch);
  const shouldFetch = useArtists(x => x.shouldFetch);
  useEffect(() => {
    if (!artist && shouldFetch(id)) {
      fetch(id);
    }
  }, [artist, id, fetch, shouldFetch]);

  return (
    <IonItem
      className='inner-chill'
      detail={true}
      routerLink={`/artist/${id}`}
      onClick={() => {}}
    >
      <IonButtons slot='start'>
        {artist && <ArtistButton variant='avatar' artist={artist} />}
      </IonButtons>
      <IonButtons>
        <IonCol>
          <IonLabel className='ion-text-center'>
            {artist?.alias?.trim() || 'Unknown artist'}
          </IonLabel>
        </IonCol>
      </IonButtons>
      <IonButtons slot='end'>
        {artist && artist.songs}
        <IonIcon icon={musicalNote} aria-hidden="true" />
      </IonButtons>
    </IonItem>
  );
};

export default ArtistItem;
